module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"listIsEmpty":"List is empty.","noDataToShow":"No data to show.","add":"Add"},"ru":{"listIsEmpty":"Список пуст.","noDataToShow":"Нет данных.","add":"Добавить"},"ua":{"listIsEmpty":"Список порожній.","noDataToShow":"Дані відсутні.","add":"Додати"}}')
  delete Component.options._Ctor
}
